import { useCallback } from 'react';
import * as reactRouter from 'react-router-dom';

const isReactRouterV6 = window.__reactRouterVersion === '6';
// @ts-expect-error -- check for storybook
const useReactRouter = window.IS_STORYBOOK
  ? () => () => {}
  : isReactRouterV6 // @ts-expect-error ---
    ? reactRouter[(() => 'useNavigate')() + (() => '')()]
    : // @ts-expect-error ---
      reactRouter[(() => 'useHistory')() + (() => '')()];

/** This can be replaced with the normal useNavigate when all apps migrate to react-router v6 */
export const useNavigate = () => {
  /* eslint-disable react-hooks/rules-of-hooks */
  if (isReactRouterV6) {
    const navigate = useReactRouter();
    return useCallback(
      (to: string, state?: unknown) => {
        if (to.startsWith('/')) navigate(to, { state });
        else window.location.href = to;
      },
      [navigate]
    );
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const history = useReactRouter();
    return useCallback(
      (to: string, state?: unknown) => {
        if (to.startsWith('/')) history.push(to, state);
        else window.location.href = to;
      },
      [history]
    );
  }
  /* eslint-enable react-hooks/rules-of-hooks */
};
